import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { utilityConfig } from '../utility/app-config';
import * as globals from '../utility/global';
import { LocalStorageService } from '../utility/local-storage.service';
import { HttpClientService } from './http-client.service';

@Injectable({
  providedIn: 'root'
})
export class PivcApiServices {
  private apiBase: string = environment.apiUrl;
  private pivcToken: string | null = null;
  //UAT
  //private oauthUsername: string = '6afp15pk35eko04bg6vdoa2mgq';
  //private oauthPassword: string = '1bfedh5v57ro83ip3usd10coqq4rm8b1dib4b8f4o8vsjni890hc';
  //prod
  private oauthUsername: string = '3depp3v8r8hbma49l4jrv16s2u';
  private oauthPassword: string = '17u2psok5tg4gket2n5bt3o58luomcb1ijutgsskb4ghschd3egg';
  private authHeader: string = LocalStorageService.get('altHeader')
    ? LocalStorageService.get('altHeader')
    : '';

  public httpOption = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Frame-Options': 'DENY',
      'SourceFrom' : utilityConfig.sourceForm
    })
  };

  public httpOptionfacecompareApi = {
    headers: new HttpHeaders({
      'Content-Type': 'multipart/form-data',
      'X-Frame-Options': 'DENY',
      'Authorization': this.authHeader,
      'Request_id': globals.currentTimeStamp,
      'SourceFrom' : utilityConfig.sourceForm
    })
  };

  constructor(private http: HttpClientService) {
    this.faceCompareaAuth();
  }

  //UAT
        //'x-api-key':'rgeWWsg5v4ZhVmTRmK9X6s56WMLsBzg8DDyLThXj'
        
  private httpOptionsWithToken(token: string) {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Frame-Options': 'DENY',
        'SourceFrom': utilityConfig.sourceForm,
        'Authorization': `Bearer ${token}`,
        'x-api-key':'EtCk1rLw6i4nAD8pWmm5RaJEnASflDf26murJaPg'
      })
    };
  }

  /*
   * API to check the valid PIVC Link
   **/
  vaildatePIVCLink(url: string, data: any) {
    this.showAjaxLoader();
    return this.getOAuthToken().pipe(
      switchMap(token =>
        this.http.Post(`${this.apiBase}/${url}`, JSON.stringify(data), this.httpOptionsWithToken(token))
      ),
      map((res: any) => {
        this.hideAjaxLoader();
        return res;
      })
    );
  }

  /*
   * API to fetch the quote details as per the user's details given in params
   **/
  getPivcPolicyDetails(url: string, data: any) {
    this.showAjaxLoader();
    return this.getOAuthToken().pipe(
      switchMap(token =>
        this.http.Post(`${this.apiBase}/${url}`, JSON.stringify(data), this.httpOptionsWithToken(token))
      ),
      map((res: any) => {
        this.hideAjaxLoader();
        return res;
      })
    );
  }

  /*
   * API to fetch the questions details as per the details given in params by user
   **/
  getPivcQuestionDetalis(url: string, data: any) {
    this.showAjaxLoader();
    return this.getOAuthToken().pipe(
      switchMap(token =>
        this.http.Post(`${this.apiBase}/${url}`, JSON.stringify(data), this.httpOptionsWithToken(token))
      ),
      map((res: any) => {
        this.hideAjaxLoader();
        return res;
      })
    );
  }

  /*
   * API to Update the questions answers details
   **/
  updatePIVCQuestionAns(url: string, data: any) {
    this.showAjaxLoader();
    return this.getOAuthToken().pipe(
      switchMap(token =>
        this.http.Post(`${this.apiBase}/${url}`, JSON.stringify(data), this.httpOptionsWithToken(token))
      ),
      map((res: any) => {
        this.hideAjaxLoader();
        return res;
      })
    );
  }

   /*
   * API to UpdatePIVCFinalStatus
   **/
  updatePIVCFinalStatus(url: string, data: any) {
    this.showAjaxLoader();
    return this.getOAuthToken().pipe(
      switchMap(token =>
        this.http.Post(`${this.apiBase}/${url}`, JSON.stringify(data), this.httpOptionsWithToken(token))
      ),
      map((res: any) => {
        this.hideAjaxLoader();
        return res;
      })
    );
  }

  /*
   * API to DMSUpload
   **/
  dmsUpload(url: string, data: any) {
    this.showAjaxLoader();
    return this.getOAuthToken().pipe(
      switchMap(token =>
        this.http.Post(`${this.apiBase}/${url}`, JSON.stringify(data), this.httpOptionsWithToken(token))
      ),
      map((res: any) => {
        this.hideAjaxLoader();
        return res;
      })
    );
  }

  /*
   * API to getPhotoPIVCVerfication
   **/
  getPhotoPIVCVerfication(url: string, data: any) {
    this.showAjaxLoader();
    return this.getOAuthToken().pipe(
      switchMap(token =>
        this.http.Post(`${this.apiBase}/${url}`, JSON.stringify(data), this.httpOptionsWithToken(token))
      ),
      map((res: any) => {
        this.hideAjaxLoader();
        return res;
      })
    );
  }



  /*
   * API to get the auth_header toekn
   **/
  faceCompareaAuth(): void {
    this.faceComapareAuthApi(utilityConfig.faceCompareAuthApi).subscribe(
      (response: any) => {
        const data: globals.faceCompareAuthApi = {...response};
        if ('status' in data && data.status === utilityConfig.successMessage) {
          this.authHeader = data.auth_header;
          LocalStorageService.set('altHeader', this.authHeader);
        }
      }
    );
  }

  /*
   * FaceComapre API Auth Key generate
   **/
  faceComapareAuthApi(url: string) {
    return this.http.Get(url);
  }

  /*
   * FaceComapre API
   **/
  faceComapareApi(url: string, data: any) {
    return this.http
      .Post(
        `${utilityConfig.faceCompareApiUrl}/${url}`,
        data,
       this.httpOptionfacecompareApi
      );
  }

  /*
   * Error Handling
   **/
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    if(error.error.ErrorMessage && error.error.ErrorMessage !== ''){
      const clientError = error.error.ErrorMessage;
      return throwError(clientError);
    }
    return throwError(errorMessage);
  }

  /**
   * Show ajax loader
   */
  showAjaxLoader() {
    const element = document.getElementById('ajax-loader');
    element.style.display = 'block';
  }

  /**
   * Show ajax loader
   */
  hideAjaxLoader() {
    const element = document.getElementById('ajax-loader');
    element.style.display = 'none';
  }

  private getOAuthToken(): Observable<string> {
    if (this.pivcToken) {
      return of(this.pivcToken);
    }

    //const body = new URLSearchParams({ grant_type: 'client_credentials' });
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Basic ${btoa(`${this.oauthUsername}:${this.oauthPassword}`)}`
    });

    return this.http
      .Post('https://apis.edelweisslife.in/oauth2/token', null, { headers })
      .pipe(
        map((res: any) => {
          this.pivcToken = res && res.access_token ? res.access_token : null;
          return this.pivcToken;
        }),
        catchError((err) => {
          console.error('Error fetching OAuth2 token:', err);
          return throwError(() => err);
        })
      );
  }
}
